<template lang="pug">
  .activity-detail
    Modal(id="split-by-bio-modal"
          :show="show"
          :modalClass="[$style.responsive]")
      template(slot="header")
        .row.align-items-center.header-row
          .col
            h2 Split by Bio
          .col-1
            div.close-button.ml-auto(aria-label="Close" @click.prevent="closeModal")
              img(src="@/assets/img/close.svg")
      template(slot="body")
        .row.mt-3
          .col-sm-auto
            strong Selected Id Key: 
            span {{ idKey }}
          .col-sm-auto
            strong Selected Bio Key: 
            span {{ bioKey }}
        .row.mt-3
          .col-sm-auto.select-dropdown-label
            strong New Bio Key:
          .col-sm-8.select-dropdown
            vSelect(id="select" v-model="selectedBio" :options="bioKeyOptions" @input="clearSplitByBioError")
        .row.mt-3
          .col-sm-10
            h4(class="form-divider")
              div - or - 
        .row.mt-3
          .col-sm-auto
            strong Last Name: 
            input(v-model="manualLastName" placeholder="e.g. Smith" @change="clearSplitByBioError")
          .col-sm-auto
            strong Birth Date: 
            input(v-model="manualBirthDate" placeholder="e.g. 01/21/1976" @change="clearSplitByBioError")
          .col-sm-auto
            strong Postal Code: 
            input(v-model="manualPostalCode" placeholder="e.g. 44319" @change="clearSplitByBioError")
        .row.mt-3
          .col-xl-2
            button.btn.btn-primary(@click.prevent="splitByBio") Replace
          .col-xl-4
            button.btn.btn-primary(@click.prevent="splitByBioNoBioKey") Replace with no BIO Key
          .col-xl-2
            button.btn.btn-primary(@click.prevent="clearContent") Clear
          .col-xl-2
            button.btn.btn-primary(@click.prevent="closeModal") Cancel
          FormError(v-if="splitByBioError")
              span(style="font-size: 0.75rem") {{ splitByBioError }}

</template>

<script>
import Modal from './Modal'
import Datatable from './Datatable'
import axios from '@/lib/axios'
import vSelect from 'vue-select'
import { globalSuccess } from '@/lib/utils'
import { globalError } from '@/lib/utils'
import { saveItem } from '@/lib/formstore'
import { parse } from 'date-fns/esm'

export default {
  name: 'SplitByBioModal',
  data: function() {
    return {
      selectedBio: '',
      manualLastName: '',
      manualBirthDate: '',
      manualPostalCode: '',
      splitByBioError: '',
    }
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    idKey: {
      type: String,
      default: "",
    },
    bioKey: {
      type: String,
      default: "",
    },
    possibleBioKeys: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    clearContent() {
      this.selectedBio = '';
      this.manualLastName = '';
      this.manualBirthDate = '';
      this.manualPostalCode = '';
      this.clearSplitByBioError();
    },
    splitByBio() {
      let checkSelected = (this.selectedBio !== "" && this.selectedBio !== null)
      let checkManual = (this.manualLastName !== "" && this.manualLastName !== null && this.manualBirthDate !== "" && this.manualBirthDate !== null && this.manualPostalCode !== "" && this.manualPostalCode !== null)

      if (checkSelected ^ checkManual) {
        if(checkSelected){
          if(this.manualLastName == "" && this.manualBirthDate == "" && this.manualPostalCode == "") {
            axios()
              .post('/api/person_summary/split_by_bio_updates', { id: this.idKey, selectedBio: this.selectedBio, bio: this.bioKey})
              .then(() => {
                this.$router.push('/my_reports');
              })
              .catch(err => globalError(err))
          } else {
            this.splitByBioError = 'Please select either a Bio Key in the dropdown or manually enter one. Do not do both.'
          }
        } else {
          if (this.dateCheck(this.manualBirthDate)) {
            axios()
              .post('/api/person_summary/split_by_bio_updates', { id: this.idKey, selectedBio: (this.manualLastName + "::" + this.manualBirthDate + "::" + this.manualPostalCode), bio: this.bioKey})
              .then(() => {
                this.$router.push('/my_reports');
              })
              .catch(err => globalError(err))
          } else {
            this.splitByBioError = 'Please enter date in valid format mm/dd/yyyy.'
          }
        }
      } else {
        this.splitByBioError = 'Please select either a Bio Key in the dropdown or manually enter one. Do not do both.'
      }
    },
    dateCheck(birthDt) {
      if (birthDt.match(/\d{2}\/\d{2}\/\d{4}/) && parse(birthDt, 'MM/dd/yyyy', new Date()).getTime()) {
        return true;
      } else {
        return false;
      }
    },
    splitByBioNoBioKey() {
      axios()
        .post('/api/person_summary/split_by_bio_updates', { id: this.idKey, selectedBio: null, bio: this.bioKey})
        .then(() => {
          this.$router.push('/my_reports');
        })
        .catch(err => globalError(err))
    },
    closeModal() {
      this.clearContent();
      this.$emit('closeDetail');
    },
    clearSplitByBioError() {
      this.splitByBioError = ''
    },
  },
  computed: {
    bioKeyOptions() {
      return this.possibleBioKeys.filter(f => f !== this.bioKey);
    }
  },
  watch: {
  },
  components: {
    Modal,
    Datatable,
    vSelect
  },
}
</script>

<style lang="scss" scoped>
.detail-table {
  tr {
    td {
      vertical-align: top;
    }
  }
}
.close-button {
  width: 2rem;
  cursor: pointer;
}

.header-row {
  height: 4rem;
}

.bg-white {
  background: white;
  border-top: 1px solid #d8d8d8;
}

button {
  width: 100%;
  margin: 1px;
}

.form-divider {
  width: 100%;
  text-align: center;
}

.select-dropdown-label {
  padding-right: 0px;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;

  -ms-flex-align: center;
  -webkit-align-items: center;
  -webkit-box-align: center;

  align-items: center;
}

.select-dropdown {
  padding-left: 5px;
}

</style>

<style>

  .vs__open-indicator {
    min-width: 15px;
  }

</style>

<style lang="scss" module>
@import '../assets/styles/breakpoints';

.responsive {
  width: 70% !important;
  height: 85% !important;

  @media (max-width: $bp-md) {
    width: 90% !important;
  }
}


</style>
